import React, { useState, useEffect } from 'react';
import Slider from 'react-input-slider';
import Calendar from 'components/common/calendar/calendar';
import Popup from 'components/common/popup/popup';
import Inputs from 'components/inputs/inputs';
import Color from 'utils/color';
import moment from 'moment';
import './datepickerModal.css';

const styles = {
  slider: {
    active: {
      backgroundColor: Color.defaults.success,
    },
  },
};

export function DatePickerModal(props) {
  const [date, setDate] = useState(new Date());

  useEffect(() => {
    if (props.date && moment(props.date).isValid()) {
      setDate(moment(props.date).toDate());
    }
  }, [props.date]);

  const handleCalendarChange = (newValue) => {
    setDate(newValue);
  };

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    if (props.onChange) {
      props.onChange(date);
    }
    props.onClose();
  };

  const renderFooter = () => {
    return (
      <>
        <Inputs.Button variant='default' onClick={handleClose} iconClass='icons8-undo' label='Cancel' />
        <Inputs.Button variant='app' onClick={handleSubmit} iconClass='icons8-checkmark' label='Apply' />
      </>
    );
  };

  return (
    <Popup
      title='Select Date'
      size='md'
      position='topscreen'
      show={props.show}
      footer={renderFooter()}
      onClose={handleClose}
    >
      <div className='d-flex justify-content-center m-2'>
        <Calendar value={date} altValue={props.altDate} calendarType='US' onChange={handleCalendarChange} />
      </div>
    </Popup>
  );
}

export function DateTimePickerModal(props) {
  const [date, setDate] = useState(new Date());
  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);

  useEffect(() => {
    if (props.date && moment(props.date).isValid()) {
      setDate(moment(props.date).toDate());
      setHour(moment(props.date).hours());
      setMinute(moment(props.date).minutes());
    }
  }, [props.date]);

  const createDate = () => {
    let d = moment(date).toDate();
    d.setHours(hour);
    d.setMinutes(minute);
    d.setSeconds(0);
    d.setMilliseconds(0);
    return d;
  };

  const handleCalendarChange = (newValue) => {
    setDate(newValue);
  };

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    date.setHours(hour);
    date.setMinutes(minute);
    if (props.onChange) {
      props.onChange(createDate());
    }
    props.onClose();
  };

  const renderFooter = () => {
    return (
      <>
        <Inputs.Button variant='default' onClick={handleClose} iconClass='icons8-undo' label='Cancel' />
        <Inputs.Button variant='app' onClick={handleSubmit} iconClass='icons8-checkmark' label='Apply' />
      </>
    );
  };

  const getFormattedTimeString = (num) => {
    return num < 10 ? '0' + num.toString() : num;
  };

  return (
    <Popup
      title='Select Date &amp; Time'
      size='md'
      position='topscreen'
      show={props.show}
      footer={renderFooter()}
      onClose={handleClose}
    >
      <div className='d-flex justify-content-center m-2'>
        <Calendar value={date} altValue={props.altDate} calendarType='US' onChange={handleCalendarChange} />
      </div>

      <div className='datepicker-modal-controls d-flex flex-wrap justify-content-center'>
        <div className='m-2 px-1'>
          <div>Hour</div>
          <Slider className='datepicker-modal-slider' axis='x' xmax={23} x={hour} onChange={({ x }) => setHour(x)} styles={styles.slider} />
          <div>Minute</div>
          <Slider className='datepicker-modal-slider' axis='x' xmax={59} x={minute} onChange={({ x }) => setMinute(x)} styles={styles.slider} />
        </div>
        <div className='datepicker-modal-controls-input-holder'>
          <Inputs.Integer min='0' max='23' value={getFormattedTimeString(hour)} deferChange={true} onValueChange={setHour} />
          <span>:</span>
          <Inputs.Integer min='0' max='59' value={getFormattedTimeString(minute)} deferChange={true} onValueChange={setMinute} />
        </div>
      </div>
    </Popup>
  );
}

export function TimePickerModal(props) {
  const [hour, setHour] = useState(0);
  const [minute, setMinute] = useState(0);

  useEffect(() => {
    setHour(props.hour);
    setMinute(props.minute);
  }, [props.hour, props.minute]);

  const handleClose = () => {
    props.onClose();
  };

  const handleSubmit = () => {
    if (props.onChange) {
      props.onChange(hour, minute);
    }
    props.onClose();
  };

  const renderFooter = () => {
    return (
      <>
        <Inputs.Button variant='default' onClick={handleClose} iconClass='icons8-undo' label='Cancel' />
        <Inputs.Button variant='app' onClick={handleSubmit} iconClass='icons8-checkmark' label='Apply' />
      </>
    );
  };

  const getFormattedTimeString = (num) => {
    return num < 10 ? '0' + num.toString() : num;
  };

  return (
    <Popup
      title='Select Time'
      size='md'
      position='topscreen'
      show={props.show}
      footer={renderFooter()}
      onClose={handleClose}
    >
      <div className='datepicker-modal-controls d-flex flex-wrap justify-content-center'>
        <div className='m-2 px-1'>
          <div>Hour</div>
          <Slider className='datepicker-modal-slider' axis='x' xmax={23} x={hour} onChange={({ x }) => setHour(x)} styles={styles.slider} />
          <div>Minute</div>
          <Slider className='datepicker-modal-slider' axis='x' xmax={59} x={minute} onChange={({ x }) => setMinute(x)} styles={styles.slider} />
        </div>
        <div className='datepicker-modal-controls-input-holder'>
          <Inputs.Integer min='0' max='23' value={getFormattedTimeString(hour)} deferChange={true} onValueChange={setHour} />
          <span>:</span>
          <Inputs.Integer min='0' max='59' value={getFormattedTimeString(minute)} deferChange={true} onValueChange={setMinute} />
        </div>
      </div>
    </Popup>
  );
}